import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { NotificationsModule } from '../notifications/notifications.module';
import { SharedModule, MaterialModule } from '@common/shared';
import { UserModule } from '../user/user.module';
import { LayoutComponent } from './layout.component';
import { layoutRoutes } from './layout.routing';
import { ProblemManualModule } from '@common/dialogs/problem-manual/problem-manual.module';

@NgModule({
  declarations: [LayoutComponent],
  imports: [
    HttpClientModule,
    MaterialModule,
    FuseFullscreenModule,
    FuseLoadingBarModule,
    FuseNavigationModule,
    NotificationsModule,
    UserModule,
    ProblemManualModule,
    SharedModule,
    RouterModule.forChild(layoutRoutes)
  ],
  exports: [LayoutComponent]
})
export class LayoutModule {}
